import { render, staticRenderFns } from "./HumanQueue.vue?vue&type=template&id=6f73484c&"
import script from "./HumanQueue.vue?vue&type=script&lang=js&"
export * from "./HumanQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports